import DropDown from '../lib/dropdown.js';
import Spinner from '../lib/spinner.js';

const CORE = {

	classNames: {
		// pop: 'brtn-header--main__ln__menu__item--pop',
		cart: 'brtn-header--main__ln__menu__item__btn--cart',
		quotation: 'brtn-header--main__ln__menu__item__btn--quotation'
	},

	onElements: function (els, callback, data) {
		var i = 0;

		if (typeof callback !== 'function') {
			return false;
		}

		if (typeof els !== 'object' || els == null || !('length' in els) || !els.length) {
			return false;
		}

		for (i; i < els.length; i++) {
			callback(els[i], data);
		}

		return true;

	},

	onLoadDropdown: function (el, data) {
		el.innerHTML = '<div class="brtn-loading__loader">Chargement</div>';

	},

	onChange: function (el, data) {
		el.innerHTML = data.content;

	},

	onDoneDropdown: function (el, data) {
		const onChange = function (_el, val) {
			var dataform = new FormData(_el.parentNode);

			dataform.append('action', 'update-qty');

			// CORE.onElements([el], CORE.onLoadDropdown, false);

			$.ajax({
				method: 'POST',
				url: data.isCart ? '/ajax/cart.php' : '/ajax/quotation.php',
				dataType: 'json',
				processData: false,
				contentType: false,
				data: dataform
			}).done(function (res) {

				if (res.error) {
					return;
				}
				CORE.onElements([data.target], CORE.onChange, { content: res.content.button } );
				CORE.onElements([el], CORE.onDoneDropdown, { isCart: data.isCart, content: res.content.dropdown, target: data.target } );

			});

		};

		el.innerHTML = data.content;

		Spinner({
			prefix: 'brtn',
			parentNode: el,
			onChange: onChange,
			onIncrement: onChange,
			onDecrement: onChange,
		});


	},

	onButton: function (data) {
		const $el = $(data.target);
		const isCart = $el.hasClass(CORE.classNames.cart);
		const isQuotation = $el.hasClass(CORE.classNames.quotation);

		if (!isCart && !isQuotation) {
			return;
		}
		CORE.onElements(data.dropdown, CORE.onLoadDropdown, false);

		$.ajax({
			method: 'GET',
			url: isCart ? '/ajax/cart.php' : '/ajax/quotation.php',
			dataType: 'json',
			data: {
				action: isCart ? 'mini-cart' : 'mini-quotation'
			}
		}).done(function (res) {
			// var $holder;

			if (res.error) {
				return;
			}
			// $holder = $(data.holder);

			// if (!$holder.hasClass(CORE.classNames.pop)) {
			// 	$holder.addClass(CORE.classNames.pop);
			// }
			CORE.onElements(data.dropdown, CORE.onDoneDropdown, { isCart: isCart, content: res.content, target: data.target } );

		});

	},

	construct: function () {
		DropDown({
			prefix: 'brtn-dropdown',
			onButton: CORE.onButton
		});
	}

};

export default CORE.construct;